import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';

export default function ({ actions }) {
    return (
        <Grid
            style={{
                position: 'absolute',
                bottom: 'calc(1vh + env(safe-area-inset-bottom, 0px))',
                right: '2vw',
                zIndex: '1199',
                width: 'auto'
            }}
            spacing={2}
            container
            justifyContent='flex-end'>
            {actions.map((action, i) => (
                <Grid item key={`fab_${i}`}>
                    <Fab
                        size='small'
                        variant='extended'
                        sx={{
                            opacity: 0.5,
                            '&:hover': {
                                opacity: 1
                            }
                        }}
                        onClick={action.onClick}>
                        {action.icon}
                        <Hidden smDown>
                            <Box px={1}>{action.text}</Box>
                        </Hidden>
                    </Fab>
                </Grid>
            ))}
        </Grid>
    );
}
